import React from 'react';

const DashboardHome = () => {
    return (
        <div className='min-h-screen flex items-center justify-center'>
            <p className='text-4xl md:text-7xl font-thin'>C</p>
            <div className='w-6 h-6 md:w-10 md:h-10 border-8 border-dashed rounded-full animate-spin mt-5 border-green-400'></div>
            <p className='md:text-7xl text-3xl font-thin'>mputer Plus</p>

        </div>
    );
};

export default DashboardHome;